import PropTypes from 'prop-types';

// project imports
import DrawerHeaderStyled from './DrawerHeaderStyled';
import Logo from 'components/logo';

// ==============================|| DRAWER HEADER ||============================== //

export default function DrawerHeader({ open }) {
  return (
    <DrawerHeaderStyled
      open={open}
      sx={{
        minHeight: '64px',
        width: 'initial',
        paddingTop: '12px',
        paddingBottom: '12px',
        paddingLeft: open ? '24px' : 0,
        borderBottom: '1px solid rgba(31, 91, 64, 0.08)',
        bgcolor: 'rgba(255, 255, 255, 0.6)',
        transition: 'padding 280ms ease-in-out',
      }}
    >
      {open && <Logo sx={{ width: 'auto', height: 40 }} />}
    </DrawerHeaderStyled>
  );
}

DrawerHeader.propTypes = { open: PropTypes.bool };
